/* tslint:disable */
/* eslint-disable */
/**
 * E.ON Home Admin Portal - API
 * # Introduction    This API provides access to admin and customer management.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: sebastian.eggers@eon.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AccountChangeEmailModel,
  AccountGetAccountUsersByIdsUserIdsParameterInner,
  AccountOrderRequestQuery,
  AccountUserAddModel,
  AccountUserModifyModel,
  AccountUsersResponseModel,
  ActivityLogFilter,
  BadRequest,
  Conflict,
  CustomerResponseModel,
  Forbidden,
  NotFound,
  OAuthClientCredentialsAddModel,
  OAuthClientCredentialsGenerateResponse,
  OAuthClientCredentialsResetModel,
  OAuthClientCredentialsResponse,
  PaginatedActivityLogResponse,
  Unauthorized,
} from '../models';

export interface AccountAddAccountUserRequest {
    accountUserAddModel: AccountUserAddModel;
}

export interface AccountChangeAccountEmailRequest {
    accountChangeEmailModel: AccountChangeEmailModel;
}

export interface AccountDeleteClientCredentialsRequest {
    id: string;
}

export interface AccountGenerateClientCredentialsRequest {
    oAuthClientCredentialsAddModel: OAuthClientCredentialsAddModel;
}

export interface AccountGetAccountUsersRequest {
    page?: number;
    limit?: number;
    filterValue?: string;
    order?: AccountOrderRequestQuery;
}

export interface AccountGetAccountUsersByIdsRequest {
    userIds: Array<AccountGetAccountUsersByIdsUserIdsParameterInner>;
    page?: number;
    limit?: number;
    order?: AccountOrderRequestQuery;
}

export interface AccountGetAuditLogsForAccountRequest {
    filter: ActivityLogFilter;
    page?: number;
    limit?: number;
}

export interface AccountModifyAccountUserRequest {
    id: string;
    accountUserModifyModel: AccountUserModifyModel;
}

export interface AccountRemoveAccountUserRequest {
    id: string;
}

export interface AccountRemoveUserMultiFactorAuthRequest {
    id: string;
}

export interface AccountResetClientCredentialsRequest {
    oAuthClientCredentialsResetModel: OAuthClientCredentialsResetModel;
}

/**
 * 
 */
export class AccountApi extends runtime.BaseAPI {

    /**
     * Creates a new user account with specified roles and sends an invitation email. The user must have a unique email address
     * Add User to Account
     */
    async accountAddAccountUserRaw(requestParameters: AccountAddAccountUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.accountUserAddModel === null || requestParameters.accountUserAddModel === undefined) {
            throw new runtime.RequiredError('accountUserAddModel','Required parameter requestParameters.accountUserAddModel was null or undefined when calling accountAddAccountUser.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/account/users`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.accountUserAddModel,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Creates a new user account with specified roles and sends an invitation email. The user must have a unique email address
     * Add User to Account
     */
    async accountAddAccountUser(requestParameters: AccountAddAccountUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.accountAddAccountUserRaw(requestParameters, initOverrides);
    }

    /**
     * Updates the user\'s email address in the Identity Provider. Sends verification emails to both old and new addresses to confirm the change
     * Change Account Email Address
     */
    async accountChangeAccountEmailRaw(requestParameters: AccountChangeAccountEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.accountChangeEmailModel === null || requestParameters.accountChangeEmailModel === undefined) {
            throw new runtime.RequiredError('accountChangeEmailModel','Required parameter requestParameters.accountChangeEmailModel was null or undefined when calling accountChangeAccountEmail.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/account/email`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.accountChangeEmailModel,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Updates the user\'s email address in the Identity Provider. Sends verification emails to both old and new addresses to confirm the change
     * Change Account Email Address
     */
    async accountChangeAccountEmail(requestParameters: AccountChangeAccountEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.accountChangeAccountEmailRaw(requestParameters, initOverrides);
    }

    /**
     * Initiates the password reset process for the authenticated user. Sends a password reset link to the user\'s registered email address
     * Send Password Reset Email
     */
    async accountChangeAccountPasswordRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/account/changePassword`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Initiates the password reset process for the authenticated user. Sends a password reset link to the user\'s registered email address
     * Send Password Reset Email
     */
    async accountChangeAccountPassword(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.accountChangeAccountPasswordRaw(initOverrides);
    }

    /**
     * Permanently removes OAuth client credentials. All API access using these credentials will be immediately revoked
     * Delete OAuth Client Credentials
     */
    async accountDeleteClientCredentialsRaw(requestParameters: AccountDeleteClientCredentialsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling accountDeleteClientCredentials.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/account/client-credentials/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Permanently removes OAuth client credentials. All API access using these credentials will be immediately revoked
     * Delete OAuth Client Credentials
     */
    async accountDeleteClientCredentials(requestParameters: AccountDeleteClientCredentialsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.accountDeleteClientCredentialsRaw(requestParameters, initOverrides);
    }

    /**
     * Creates new OAuth 2.0 client credentials for programmatic API access. Returns client ID and secret (secret is only shown once)
     * Generate OAuth Client Credentials
     */
    async accountGenerateClientCredentialsRaw(requestParameters: AccountGenerateClientCredentialsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OAuthClientCredentialsGenerateResponse>>> {
        if (requestParameters.oAuthClientCredentialsAddModel === null || requestParameters.oAuthClientCredentialsAddModel === undefined) {
            throw new runtime.RequiredError('oAuthClientCredentialsAddModel','Required parameter requestParameters.oAuthClientCredentialsAddModel was null or undefined when calling accountGenerateClientCredentials.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/account/client-credentials`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.oAuthClientCredentialsAddModel,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Creates new OAuth 2.0 client credentials for programmatic API access. Returns client ID and secret (secret is only shown once)
     * Generate OAuth Client Credentials
     */
    async accountGenerateClientCredentials(requestParameters: AccountGenerateClientCredentialsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OAuthClientCredentialsGenerateResponse>> {
        const response = await this.accountGenerateClientCredentialsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves detailed information about the authenticated user\'s account including customer details, status, and configuration
     * Get Account Information
     */
    async accountGetAccountRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerResponseModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/account`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves detailed information about the authenticated user\'s account including customer details, status, and configuration
     * Get Account Information
     */
    async accountGetAccount(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerResponseModel> {
        const response = await this.accountGetAccountRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieves a paginated list of users associated with the account. Supports filtering by username/email and sorting
     * Get Account Users
     */
    async accountGetAccountUsersRaw(requestParameters: AccountGetAccountUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AccountUsersResponseModel>> {
        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.filterValue !== undefined) {
            queryParameters['filterValue'] = requestParameters.filterValue;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/account/users`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves a paginated list of users associated with the account. Supports filtering by username/email and sorting
     * Get Account Users
     */
    async accountGetAccountUsers(requestParameters: AccountGetAccountUsersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AccountUsersResponseModel> {
        const response = await this.accountGetAccountUsersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves specific users by their IDs with pagination and sorting support. Useful for bulk user information retrieval
     * Get Account Users by IDs
     */
    async accountGetAccountUsersByIdsRaw(requestParameters: AccountGetAccountUsersByIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AccountUsersResponseModel>> {
        if (requestParameters.userIds === null || requestParameters.userIds === undefined) {
            throw new runtime.RequiredError('userIds','Required parameter requestParameters.userIds was null or undefined when calling accountGetAccountUsersByIds.');
        }

        const queryParameters: any = {};

        if (requestParameters.userIds) {
            queryParameters['userIds'] = requestParameters.userIds;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/account/usersByIds`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves specific users by their IDs with pagination and sorting support. Useful for bulk user information retrieval
     * Get Account Users by IDs
     */
    async accountGetAccountUsersByIds(requestParameters: AccountGetAccountUsersByIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AccountUsersResponseModel> {
        const response = await this.accountGetAccountUsersByIdsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns all available filter options for activity logs including sources, applications, action types, and object sources. Use this to build dynamic filter UIs
     * Get Available Activity Log Filters
     */
    async accountGetActivitiesFiltersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/account/activities/filters`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Returns all available filter options for activity logs including sources, applications, action types, and object sources. Use this to build dynamic filter UIs
     * Get Available Activity Log Filters
     */
    async accountGetActivitiesFilters(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.accountGetActivitiesFiltersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieves paginated audit logs for account activities including user actions, data changes, and system events. Supports filtering by source, application, action type, and date range
     * Get Account Activity Logs
     */
    async accountGetAuditLogsForAccountRaw(requestParameters: AccountGetAuditLogsForAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedActivityLogResponse>> {
        if (requestParameters.filter === null || requestParameters.filter === undefined) {
            throw new runtime.RequiredError('filter','Required parameter requestParameters.filter was null or undefined when calling accountGetAuditLogsForAccount.');
        }

        const queryParameters: any = {};

        if (requestParameters.filter !== undefined) {
            queryParameters['filter'] = requestParameters.filter;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/account/activities`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves paginated audit logs for account activities including user actions, data changes, and system events. Supports filtering by source, application, action type, and date range
     * Get Account Activity Logs
     */
    async accountGetAuditLogsForAccount(requestParameters: AccountGetAuditLogsForAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedActivityLogResponse> {
        const response = await this.accountGetAuditLogsForAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all active OAuth client credentials for the account. Client secrets are not included in the response for security reasons
     * List OAuth Client Credentials
     */
    async accountGetClientCredentialsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OAuthClientCredentialsResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/account/client-credentials`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves all active OAuth client credentials for the account. Client secrets are not included in the response for security reasons
     * List OAuth Client Credentials
     */
    async accountGetClientCredentials(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OAuthClientCredentialsResponse>> {
        const response = await this.accountGetClientCredentialsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Updates an existing user\'s profile information including name, country, roles, and language preferences
     * Update User Information
     */
    async accountModifyAccountUserRaw(requestParameters: AccountModifyAccountUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling accountModifyAccountUser.');
        }

        if (requestParameters.accountUserModifyModel === null || requestParameters.accountUserModifyModel === undefined) {
            throw new runtime.RequiredError('accountUserModifyModel','Required parameter requestParameters.accountUserModifyModel was null or undefined when calling accountModifyAccountUser.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/account/users/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.accountUserModifyModel,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Updates an existing user\'s profile information including name, country, roles, and language preferences
     * Update User Information
     */
    async accountModifyAccountUser(requestParameters: AccountModifyAccountUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.accountModifyAccountUserRaw(requestParameters, initOverrides);
    }

    /**
     * Permanently removes a user from the account. This action cannot be undone and will revoke all user access
     * Remove User from Account
     */
    async accountRemoveAccountUserRaw(requestParameters: AccountRemoveAccountUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling accountRemoveAccountUser.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/account/users/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Permanently removes a user from the account. This action cannot be undone and will revoke all user access
     * Remove User from Account
     */
    async accountRemoveAccountUser(requestParameters: AccountRemoveAccountUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.accountRemoveAccountUserRaw(requestParameters, initOverrides);
    }

    /**
     * Removes multi-factor authentication (MFA) settings for a user, allowing them to reconfigure MFA on next login
     * Disable User Multi-Factor Authentication
     */
    async accountRemoveUserMultiFactorAuthRaw(requestParameters: AccountRemoveUserMultiFactorAuthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling accountRemoveUserMultiFactorAuth.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/account/users/{id}/multifactor`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Removes multi-factor authentication (MFA) settings for a user, allowing them to reconfigure MFA on next login
     * Disable User Multi-Factor Authentication
     */
    async accountRemoveUserMultiFactorAuth(requestParameters: AccountRemoveUserMultiFactorAuthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.accountRemoveUserMultiFactorAuthRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Regenerates the client secret for existing credentials. The old secret will be invalidated immediately. New secret is only shown once
     * Reset OAuth Client Credentials Secret
     */
    async accountResetClientCredentialsRaw(requestParameters: AccountResetClientCredentialsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OAuthClientCredentialsGenerateResponse>>> {
        if (requestParameters.oAuthClientCredentialsResetModel === null || requestParameters.oAuthClientCredentialsResetModel === undefined) {
            throw new runtime.RequiredError('oAuthClientCredentialsResetModel','Required parameter requestParameters.oAuthClientCredentialsResetModel was null or undefined when calling accountResetClientCredentials.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/account/client-credentials/reset`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.oAuthClientCredentialsResetModel,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Regenerates the client secret for existing credentials. The old secret will be invalidated immediately. New secret is only shown once
     * Reset OAuth Client Credentials Secret
     */
    async accountResetClientCredentials(requestParameters: AccountResetClientCredentialsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OAuthClientCredentialsGenerateResponse>> {
        const response = await this.accountResetClientCredentialsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Triggers the email validation process for the authenticated user via the Identity Provider. Sends a verification email to the user\'s registered address
     * Send Account Validation Email
     */
    async accountValidateAccountRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/account/validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Triggers the email validation process for the authenticated user via the Identity Provider. Sends a verification email to the user\'s registered address
     * Send Account Validation Email
     */
    async accountValidateAccount(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.accountValidateAccountRaw(initOverrides);
    }

}
